//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line no-unused-vars
import moment from 'moment';

import { BTooltip } from 'bootstrap-vue';
import InlineSpinner from '../../../common/InlineSpinner.vue';

export default {
  components: {
    BTooltip,
    InlineSpinner,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    connections: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      loading: false,
      selectedCohort: {},
      permissionLevels: [
        {
          title: 'None – Stop Sharing Data',
          description: 'Your permission to share data is immediately revoked.',
        },
        {
          title: 'Aggregated only: no personal-level info',
          description: 'Your data and information may only be shared in aggregate, meaning that you will be one of many anonymous individuals contributing to a metric that is calculated across the entire group. None of your individual workouts are shared - only aggregate metrics that combine your data along with similar data provided by others.',
        },
        {
          title: 'Anonymized with no contact info',
          description: 'Your wearables data may be shared, though the most sensitive & personally identifiable information will not be shared. Exact GPS coordinates from workouts are withheld, as are exact birthdate, your name, and your contact information (email address). Individual workouts may be shared, but you will not be personally identified.',
        },
        {
          title: 'Identified & able to be contacted (recommended)',
          description: 'This is the most inclusive set of permissions. Your wearables data may be shared, including exact GPS coordinates in recorded workouts. Personal and identifiable information including your name, birthdate, and contact information (email address) may also be shared.',
        },
      ],
      permission: 0,
    };
  },

  methods: {
    handleOpenDialog() {
      this.isOpen = !this.isOpen;
    },

    handleManageCohort(cohort) {
      this.selectedCohort = cohort;
      this.permission = cohort.permissions;
      this.$refs.managePermissionsModalRef.show();
    },

    formatDate(date) {
      return moment(date, 'YYYYMMDD').fromNow();
    },

    // eslint-disable-next-line consistent-return
    async handleCohortMemberUpdatePermissions(id, permissions) {
      this.loading = true;
      try {
        await this.$api.updateCohortMemberPermissions(id, permissions);
        this.selectedCohort = {};
      } catch (error) {
        console.log(error);
      } finally {
        this.$emit('updated');
        this.loading = false;
      }
    },
  },

  computed: {
    amountConnections() {
      const num = this.connections.length;
      return num > 1 ? `${num} connections.` : `${num} connection.`;
    },
  },
};
